<!--  -->
<template>
  <div class="comContent contentInner">
    <div class="topSearch">
      <el-row class="top" :gutter="8" style="width: 100%">
        <el-form ref="formTool" :model="formTool" :inline="true">
          <el-col :span="3">
            <el-form-item prop="province">
              <el-select
                v-model="formTool.province"
                size="small"
                clearable
                placeholder="请选择省"
                @change="provinceBtn"
              >
                <el-option
                  v-for="(item, index) in provinceData"
                  :key="index"
                  :label="item.rname"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="city">
              <el-select
                v-model="formTool.city"
                size="small"
                clearable
                placeholder="请选择市"
                @change="cityBtn"
              >
                <el-option
                  v-for="(item, index) in cityData"
                  :key="index"
                  :label="item.rname"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="area">
              <el-select
                v-model="formTool.area"
                size="small"
                clearable
                placeholder="请选择区"
                @change="areaBtn"
              >
                <el-option
                  v-for="(item, index) in areaData"
                  :key="index"
                  :label="item.rname"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="shopTypeCode">
              <el-select
                v-model="formTool.shopTypeCode"
                size="small"
                clearable
                placeholder="商户类型"
              >
                <el-option
                  v-for="(item, index) in shopList"
                  :key="index"
                  :label="item.typeName"
                  :value="item.typeCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="certifyStatus">
              <el-select
                v-model="formTool.certifyStatus"
                size="small"
                clearable
                placeholder="资质状态"
              >
                <el-option
                  v-for="(item, index) in certifyStatusList"
                  :key="index"
                  :label="item.typeName"
                  :value="item.typeCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="shopName">
              <el-input
                v-model="formTool.shopName"
                clearable
                placeholder="企业名称"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="concatPhone">
              <el-input
                v-model="formTool.concatPhone"
                clearable
                placeholder="登录用户名"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div class="second">
        <div
          style="display: inline-block; margin-right: 16px"
          v-if="tabsIndex != '2' && tabsIndex != '1' && tabsIndex != '-2'"
        >
          <span class="demonstration" style="">提交日期： </span>
          <el-date-picker
            v-model="value1"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            size="small"
            clearable
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div
          style="display: inline-block; margin-right: 16px"
          v-if="tabsIndex != '0' && tabsIndex != '-2' && tabsIndex != '-1'"
        >
          <span class="demonstration">审核日期：</span>
          <el-date-picker
            v-model="value2"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            size="small"
            clearable
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div style="display: inline-block; margin-right: 16px">
          <span class="demonstration" style="">所属省办/地办： </span>
          <el-cascader
            ref="selectDom"
            v-model="select"
            :props="{ checkStrictly: true }"
            clearable
            placeholder="请选择关联组织"
            size="mini"
            :options="selectData"
            @change="selectChange"
          />
        </div>
        <MyButton type="primary" text="查询" @click="goSearch" />
        <el-button size="small" @click="reset()">重置</el-button>
        <el-button size="small" @click="download()">导出</el-button>
      </div>
    </div>
    <div class="titleInner">
      <MyTabs
        class="search"
        :tabi="tabsIndex"
        keyname="val"
        :tabs="tabsData"
        @change="tabChange"
      />
    </div>
    <div class="center">
      <MyTable
        :table-data="tableData"
        @sort-change="sortChange"
        :index="index"
        :selection="selection"
        :page="page"
        :operation="operation"
        :table-option.sync="tableOption"
        @page-change="getcheckList"
        @handleSelectionChange="currentChange"
      >
        <!-- <template slot="image" slot-scope="scope">
          <el-image :src="scope.row.image" style="width: 80px; height: 80px" />
        </template> -->
        <template slot="shopName" slot-scope="scope">
          <div>{{ scope.row.shopName }}</div>
          <!-- 风险提示 异常项-->
          <el-tag
            type="danger"
            size="mini"
            v-if="scope.row.riskCount != null && scope.row.riskCount > 0"
            >{{ scope.row.riskCount }}项异常</el-tag
          >
          <el-tag
            type="success"
            size="mini"
            v-else-if="scope.row.riskCount != null && scope.row.riskCount == 0"
            >风险校验正常</el-tag
          >
        </template>
        <template slot="status" slot-scope="scope">
          <!-- <MyTypes :type="scope.row.status" /> -->
          <div class="inline">
            <div
              class="dot"
              :style="{
                'background-color': getDotColor(scope.row.certifyStatus),
              }"
            ></div>
            <span>{{ scope.row.certifyStatus || "" }}</span>
          </div>
        </template>

        <template slot="certDate" slot-scope="scope">
          <div
            v-for="(item, key) in scope.row.normalCertifyList"
            :key="key + item.endDate"
          >
            <span class="certify-name"> {{ item.certifyName }}: </span>
            <span>
              {{ item.endDate }}
            </span>
          </div>
          <div
            v-for="(item, key) in scope.row.nearEndDateCertifyList"
            :key="key + item.endDate"
            style="color: orange"
          >
            <span class="certify-name"> {{ item.certifyName }}: </span>
            <span>
              {{ item.endDate }}
            </span>
          </div>
          <div
            v-for="(item, key) in scope.row.expireDateCertifyList"
            :key="key + item.endDate"
            style="color: red"
          >
            <span class="certify-name"> {{ item.certifyName }}: </span>
            <span>
              {{ item.endDate }}
            </span>
          </div>
        </template>

        <template slot="address" slot-scope="scope">
          <div>
            <span>
              {{ scope.row.provinceName || "" }}
            </span>
            <span>
              {{ scope.row.cityName || "" }}
            </span>
            <span>
              {{ scope.row.areaName || "" }}
            </span>
            <span>
              {{ scope.row.address ? scope.row.address : "" }}
            </span>
          </div>
        </template>
        <template slot="beStop" slot-scope="scope">
          <el-switch
            v-model="scope.row.beStop"
            active-text="正常"
            inactive-text="停用"
            :active-value="false"
            active-color="#13ce66"
            :inactive-value="true"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
        <template slot="menu" slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="editDetail(scope.row)">审核</el-button> -->
          <el-link
            :underline="false"
            type="primary"
            v-if="scope.row.status == '20' && permissions.second_check"
            @click="editDetail(scope.row)"
            >{{ "二审" }}</el-link
          >
          <el-link
            :underline="false"
            style="margin-left: 8px"
            type="primary"
            v-if="scope.row.status == '0'"
            @click="editDetail(scope.row, tabsIndex)"
            >{{ "初审" }}</el-link
          >
          <el-link
            :underline="false"
            style="margin-left: 8px"
            type="primary"
            @click="detailInfo(scope.row)"
            >详情</el-link
          >
          <!-- <el-link :underline="false"
                   style="margin-left:8px"
                   type="primary"
                   @click="uploadZizhi(scope.row)">资质下载</el-link> -->
          <el-link
            v-if="tabsIndex != '-2' && permissions.zizhi_audit_log"
            :underline="false"
            style="margin-left: 8px"
            type="primary"
            @click="auditHistory(scope.row)"
            >审核日志</el-link
          >
          <el-link
            v-if="
              permissions.delete_certification &&
              scope.row.status != '-2' &&
              scope.row.status != null
            "
            :underline="false"
            style="margin-left: 8px"
            type="primary"
            @click="handleDeleteCertify(scope.row)"
            >删除资质</el-link
          >
        </template>
      </MyTable>
    </div>
    <el-dialog
      title="操作日志"
      width="700px"
      border
      :visible.sync="dialogTableVisible"
    >
      <el-table :data="gridData" style="height: 100%; overflow: auto">
        <el-table-column type="index" label="序号" />
        <el-table-column
          property="updateBy"
          label="操作人"
          width="120"
        ></el-table-column>
        <el-table-column label="操作内容" width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.auditOperat == "2" ? "审核通过" : "驳回"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="remarks"
          label="备注"
          width="200"
        ></el-table-column>
        <el-table-column
          property="updateTime"
          label="操作时间"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import MyButton from "@/components/myButton";
import MyTable from "@/components/myTable";
import MyTabs from "@/components/myTabs";
import MyTypes from "@/components/myTypes";
import {
  auditCompanyList,
  auditCompanyListReady,
  downloadShopcertify,
  deptTree,
  deleteCertify,
  stopCertify,
} from "@/api/auditcenter";
import {
  getShoparea,
  regionProvince,
  regionCity,
  regionArea,
  download,
} from "@/api/merchantsettlement/index";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  name: "auditcompany",
  components: { MyButton, MyTable, MyTabs, MyTypes },
  data() {
    return {
      selectData: [],
      select: "", // 省办或者地办
      pickerOptions: {
        shortcuts: [
          {
            text: "昨日",
            onClick(picker) {
              const start = dayjs().add(-1, "day").format("YYYY-MM-DD");
              const end = dayjs().add(-1, "day").format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "今日",
            onClick(picker) {
              const end = dayjs().add(0, "day").format("YYYY-MM-DD");
              const start = dayjs().add(0, "day").format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近3日",
            onClick(picker) {
              const start = dayjs().add(-3, "day").format("YYYY-MM-DD");
              const end = dayjs().add(0, "day").format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近7日",
            onClick(picker) {
              const start = dayjs().add(-7, "day").format("YYYY-MM-DD");
              const end = dayjs().add(0, "day").format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近30日",
            onClick(picker) {
              const start = dayjs().add(-30, "day").format("YYYY-MM-DD");
              const end = dayjs().add(0, "day").format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      order: "DESC", //升序或者降序
      radio1: "",
      // 商户类型
      shopList: [],
      certifyStatusList: [
        {
          typeName: "过期",
          typeCode: 2,
        },
        {
          typeName: "临期",
          typeCode: 3,
        },
        {
          typeName: "正常",
          typeCode: 1,
        },
      ],
      dialogTableVisible: false,
      gridData: [],

      text: "",
      clearable: true,
      provinceData: {},
      cityData: [],
      areaData: [],
      value1: [], // 提交时间
      value2: [], // 审核时间
      formTool: {
        certifyStatus: "",
        shopTypeCode: "",
        province: "",
        city: "",
        area: "",
        shopName: "",
        concatPhone: "",
      },
      tabsData: [
        { name: "全部", num: 0, val: "-1", numhide: true },
        { name: "待审核", num: 0, val: "0", numhide: true },
        { name: "初审通过", num: 0, val: "20", numhide: true },
        { name: "二审通过", num: 0, val: "2", numhide: true },
        { name: "驳回", num: 0, val: "1", numhide: true },
        { name: "资质准备中", num: 0, val: "-2", numhide: true },
      ],
      tabsIndex: "-1",
      operation: true,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        // { label: '编号', prop: 'id' },
        { label: "企业名称", prop: "shopName", slot: true }, // 这里表示自定义列 , slot: true
        { label: "企业类型", prop: "shopTypeName" },
        { label: "登录用户名", prop: "loginUserName" },
        { label: "提交时间", prop: "submitTime", sortable: "custom" },
        { label: "审核时间", prop: "auditTime" },
        { label: "详细地址", prop: "address", slot: true, width: "300px" },
        { label: "资质状态", prop: "status", slot: true, width: "100px" },
        { label: "证件有效期", prop: "certDate", slot: true, width: "240px" },
        { label: "企业状态", prop: "beStop", slot: true, width: "150px" },
        // { label: '操作', prop: 'menu' }
      ],
      page: {
        total: 0,
        current: 1,
        size: 30,
        pageSizes: [30, 50, 100, 500],
      },
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    // 当前登录账号是否为 admin（仅 admin 显示"企业状态"列）
    isAdmin() {
      const info = (this.$store && this.$store.state.user.user_info) || {};
      return (info.username || info.userName || info.account) === "admin";
    },
  },
  watch: {},
  created() {
    this.tableOption = this.filterAdminColumns(this.tableOption);
    this.getDeptTree();
    this.getShoparea();
    this.getProvince();
    this.getcheckList();
  },
  mounted() {
    if (this.$route.query.shopName) {
      this.formTool.shopName = this.$route.query.shopName;
    }
  },
  activated() {
    this.getcheckList();
  },
  methods: {
    getDotColor(str) {
      // 资质颜色
      if (!str) {
        return "#ffffff";
      }
      let color = "#ffffff";
      switch (str) {
        case "待审核":
          color = "#f99b0d";
          break;
        case "初审通过":
          color = "#f99b0d";
          break;
        case "驳回":
          color = "#f5222d";
          break;
        case "过期":
          color = "#f5222d";
          break;
        case "临期":
          color = "#f99b0d";
          break;
        case "正常":
          color = "#67c23a";
          break;
        default:
          color = "#ffffff";
          break;
      }
      return color;
    },
    // 查询省地关系
    getDeptTree() {
      deptTree().then((res) => {
        // let new_d = deepClone(res.data)
        // new_d[0].id = 11111
        // console.log(new_d)
        // console.log(res.data)
        if (res.code === 0) {
          // this.info = res.data
          // this.deptData = this.treeReset(res.data)
          // this.selectData = deepClone(this.deptData)
          this.selectData = this.treeReset(res.data);
        }
      });
    },
    treeReset(arrData) {
      let t = this;
      return arrData.map((li) => {
        let d = {
          label: li.orgName,
          value: li.orgCode,
          code: li.orgCode,
        };
        if (li.children && li.children.length > 0) {
          d.children = t.treeReset(li.children);
        }
        return d;
      });
    },
    selectChange(val) {
      // debugger
      // let checkEl = this.$refs['selectDom'].getCheckedNodes()
      // console.log(checkEl)
      // this.select = checkEl[0].data.value
    },
    // 表格排序
    sortChange(val) {
      if (val.order == "ascending") {
        this.order = "ASC";
      } else {
        this.order = "DESC";
      }
      this.getcheckList();
    },
    getShoparea() {
      getShoparea(0).then((res) => {
        if (res.code === 0) {
          this.shopList = res.data;
          // this.numberValidateForm.typeCode = res.data[0].typeCode;
        }
      });
    },
    getProvince() {
      regionProvince().then((res) => {
        if (res.code === 0) {
          this.provinceData = res.data;
        }
      });
    },
    provinceBtn(item) {
      this.cityData = [];
      this.areaData = [];
      if (!item) {
        this.formTool.city = ``;
        this.formTool.area = ``;
      } else {
        // const provinceIndex = this.provinceData.findIndex(
        //   (res) => res.id === item
        // );
        // this.formTool.provinceName =
        //   this.provinceData[provinceIndex].rname;
        regionCity(item).then((res) => {
          this.cityData = res.data;
          this.formTool.city = ``;
          this.formTool.area = ``;
        });
      }
    },
    cityBtn(item) {
      this.areaData = [];
      if (!item) {
        this.formTool.area = ``;
      } else {
        // const cityIndex = this.cityData.findIndex((res) => res.id === item);
        // this.formTool.cityName = this.cityData[cityIndex].rname;
        regionArea(item).then((res) => {
          this.formTool.area = "";
          this.areaData = res.data;
        });
      }
    },
    areaBtn(item) {
      if (!item) {
        this.formTool.area = ``;
      } else {
        // const areaIndex = this.areaData.findIndex((res) => res.id === item);
        // this.formTool.areaName = this.areaData[areaIndex].rname;
      }
    },
    // 资质下载
    uploadZizhi(row) {
      downloadShopcertify(row.id).then((res) => {
        if (res.code == 0) {
        } else {
          this.$message.error("资质下载出错");
        }
      });
    },
    // 导出
    download() {
      const { current, size } = this.page;
      let params = {
        current,
        size,
        status: this.tabsIndex,
        ...this.formTool,
      };
      if (this.select && this.select.length != 0) {
        let checkEl = this.$refs["selectDom"].getCheckedNodes();
        this.select = checkEl[0].data.value;
        params.orgCode = this.select;
      }
      params.startSubmitTime =
        !this.value1 || this.value1.length == 0 ? "" : this.value1[0];
      params.endSubmitTime =
        !this.value1 || this.value1.length == 0 ? "" : this.value1[1];
      params.startAuditTime =
        !this.value2 || this.value2.length == 0 ? "" : this.value2[0];
      params.endAuditTime =
        !this.value2 || this.value2.length == 0 ? "" : this.value2[1];
      download(params).then((res) => {});
    },
    // 查看日志
    auditHistory(row) {
      this.$router.push({
        path: "/audit/auditcenter-auditlog",
        query: {
          id: row.id,
        },
      });
    },
    // 停用
    changeStatus(row) {
      const content = row.beStop
        ? "此操作将停用该资质, 是否继续?"
        : "此操作将启用该资质, 是否继续?";
      this.$confirm(content, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          const params = {
            shopId: row.id,
            isStop: row.beStop,
          };
          stopCertify(params).then((res) => {
            if (res) {
              this.$message.success("修改成功");
              this.getcheckList();
            }
          });
        })
        .catch((err) => {
          row.beStop = !row.beStop;
        });
    },
    // 删除资质
    handleDeleteCertify(row) {
      this.$confirm("此操作将删除该资质, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteCertify(row);
        })
        .catch(() => {});
    },
    async deleteCertify(row) {
      const res = await deleteCertify({ id: row.id, userId: row.ownerUserId });
      if (res) {
        this.$message.success("删除成功");
        this.getcheckList();
      }
    },
    tabChange(i) {
      this.tabsIndex = i;
      this.page.current = 1;
      this.radio1 = "";
      this.value1 = [];
      this.value2 = [];
      if (i == "-1") {
        this.tableOption = [
          // { label: '编号', prop: 'id' },
          { label: "企业名称", prop: "shopName", slot: true }, // 这里表示自定义列 , slot: true
          { label: "企业类型", prop: "shopTypeName" },
          { label: "登录用户名", prop: "loginUserName" },
          { label: "提交时间", prop: "submitTime", sortable: "custom" },
          { label: "审核时间", prop: "auditTime" },
          { label: "详细地址", prop: "address", slot: true, width: "300px" },
          { label: "证件有效期", prop: "certDate", slot: true, width: "240px" },
          { label: "状态", prop: "status", slot: true, width: "100px" },
          { label: "企业状态", prop: "beStop", slot: true, width: "150px" },
          // { label: '操作', prop: 'menu' }
        ];
      } else if (i == "0") {
        this.tableOption = [
          // { label: '编号', prop: 'id' },
          { label: "企业名称", prop: "shopName", slot: true }, // 这里表示自定义列 , slot: true
          { label: "企业类型", prop: "shopTypeName" },
          { label: "登录用户名", prop: "loginUserName" },
          { label: "提交时间", prop: "submitTime", sortable: "custom" },
          // { label: '审核时间', prop: 'auditTime' },
          { label: "详细地址", prop: "address", slot: true, width: "300px" },
          { label: "证件有效期", prop: "certDate", slot: true, width: "240px" },
          { label: "状态", prop: "status", slot: true, width: "100px" },
          { label: "企业状态", prop: "beStop", slot: true, width: "150px" },
          // { label: '操作', prop: 'menu' }
        ];
      } else if (i == "-2") {
        this.tableOption = [
          // { label: '编号', prop: 'id' },
          { label: "企业名称", prop: "shopName", slot: true }, // 这里表示自定义列 , slot: true
          { label: "企业类型", prop: "shopTypeName" },
          { label: "登录用户名", prop: "loginUserName" },
          // { label: '提交时间', prop: 'submitTime', sortable: 'custom' },
          // { label: '审核时间', prop: 'auditTime' },
          { label: "详细地址", prop: "address", slot: true, width: "300px" },
          { label: "证件有效期", prop: "certDate", slot: true, width: "240px" },
          { label: "状态", prop: "status", slot: true, width: "100px" },
          // { label: '操作', prop: 'menu' }
        ];
      } else {
        this.tableOption = [
          // { label: '编号', prop: 'id' },
          { label: "企业名称", prop: "shopName", slot: true }, // 这里表示自定义列 , slot: true
          { label: "企业类型", prop: "shopTypeName" },
          { label: "登录用户名", prop: "loginUserName" },
          // { label: '提交时间', prop: 'submitTime', sortable: 'custom' },
          { label: "审核时间", prop: "auditTime" },
          { label: "详细地址", prop: "address", slot: true, width: "300px" },
          { label: "证件有效期", prop: "certDate", slot: true, width: "240px" },
          { label: "状态", prop: "status", slot: true, width: "100px" },
          { label: "企业状态", prop: "beStop", slot: true, width: "150px" },
          // { label: '操作', prop: 'menu' }
        ];
      }

      this.tableOption = this.filterAdminColumns(this.tableOption);
      this.getcheckList(i);
    },
    // 非 admin 账号不显示"企业状态"列
    filterAdminColumns(columns) {
      if (this.isAdmin) return columns;
      return columns.filter((item) => item.prop !== "beStop");
    },
    async getcheckList() {
      this.tableData = [];
      const { current, size } = this.page;
      let params = {
        current,
        size,
        status: this.tabsIndex,
        sort: this.order,
        ...this.formTool,
      };
      if (this.select && this.select.length != 0) {
        let checkEl = this.$refs["selectDom"].getCheckedNodes();
        this.select = checkEl[0].data.value;
        params.orgCode = this.select;
      }
      params.startSubmitTime =
        !this.value1 || this.value1.length == 0 ? "" : this.value1[0];
      params.endSubmitTime =
        !this.value1 || this.value1.length == 0 ? "" : this.value1[1];
      params.startAuditTime =
        !this.value2 || this.value2.length == 0 ? "" : this.value2[0];
      params.endAuditTime =
        !this.value2 || this.value2.length == 0 ? "" : this.value2[1];
      const res =
        this.tabsIndex == "-2"
          ? await auditCompanyListReady(params)
          : await auditCompanyList(params);
      // auditCompanyList(params).then((res) => {
      if (res.code === 0) {
        if (!res.data) {
          // this.$message.warning("当前查询条件下无数据");
          this.tableData = [];
          this.page.total = 0;
          this.tabsData.forEach((item) => {
            // item.num = 0
            item.numhide = true;
          });
          return;
        }
        const { records, total } = res.data;
        this.page.total = total;
        // records.forEach(item => {
        //   item.status = auditTypes(item.status)
        // })
        this.tableData = records || [];
        this.tabsData.forEach((item) => {
          if (item.val == this.tabsIndex) {
            item.num = total;
            item.numhide = false;
          } else {
            item.numhide = true;
          }
        });
      } else {
        this.$message.error(res.msg);
      }
      // });
    },
    reset() {
      this.value1 = [];
      this.value2 = [];
      this.select = this.$refs["selectDom"].handleClear();
      // this.formTool.storeName = ''
      this.$refs.formTool.resetFields();
      this.page.current = 1;
      this.getcheckList();
    },
    editDetail(row) {
      this.$router.push({
        path: "/qualification-related-user-management/qualification-audit-detail",
        query: {
          type: this.tabsIndex == "2" ? "edit" : "approve",
          shopId: row.id,
          deptId: row.deptId,
          orgCode: row.orgCode,
          roleId: row.roleId,
          status: row.status,
          shopName: row.shopName,
          shopTypeName: row.shopTypeName,
          requestId: row.requestId,
          relationType: row.relatedType,
          riskCount: row.riskCount,
        },
      });
    },
    detailInfo(row) {
      this.$router.push({
        path: "/qualification-related-user-management/qualification-audit-detail",
        query: {
          type: "view",
          shopId: row.id,
          deptId: row.deptId,
          orgCode: row.orgCode,
          roleId: row.roleId,
          status: row.status,
          shopName: row.shopName,
          shopTypeName: row.shopTypeName,
          requestId: row.requestId,
          relationType: row.relatedType,
          riskCount: row.riskCount,
        },
      });
    },
    currentChange(val) {},
    goSearch() {
      this.radio1 = "";
      this.page.current = 1;
      this.getcheckList();
    },
  },
};
</script>
<style lang="scss" scoped>
.comContent {
  ::v-deep .el-dialog__body {
    height: 500px;
  }

  .second {
    height: 56px;
    padding: 0 24px;
  }

  .top {
    height: 56px;
    padding: 0 24px;
    display: flex;
    // justify-content: center;
    align-items: center;

    .el-radio {
      margin-right: 10px;
    }

    .demonstration {
      color: #595959;
      font-size: 14px;
    }

    ::v-deep .el-form-item {
      margin-bottom: 0px !important;
      margin-right: 0px !important;

      .el-date-editor.el-input__inner {
        width: auto !important;
      }
    }
  }

  .titleInner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding: 0px 24px;

    .title {
      display: flex;
      justify-content: right;
      align-items: center;
    }

    .search {
      align-items: center;
    }
  }
}

.contentInner {
  padding: 0px;
}

.center {
  margin-top: 16px;
  padding: 0px 24px;
  height: calc(100% - 250px);
}

.inline {
  display: flex;
  align-items: center;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.certify-name {
  //width: 140px;
  //display: inline-block;
}
</style>
